

export const veoFeatures = {
    title: 'AI 视频生成的核心功能',
    subtitle:
      '先进模型带来电影级能力：关键帧控制、延长时长、多参考图、原生音频。',
    items: [
      { num: '01', title: '关键帧控制：精准起始/结尾帧', body: '用关键帧精准掌控视频开头与结尾，打造平滑过渡并保持叙事流畅。' },
      { num: '02', title: '多参考图：一致视觉风格', body: '提供多张参考图以引导角色、光照、色调，确保全片视觉一致。' },
      { num: '03', title: '原生音频与强化音效', body: '自动生成对白、环境音与动作同步音效，与画面完美对齐。' },
      { num: '04', title: '延长视频时长（超过 8 秒）', body: '突破 8 秒限制，让叙事自然延续，创作更丰富的视频。' }
    ]
  };
